import PropTypes from "prop-types";

const AddOptionDropdown = ({ options, handleAddOptionClick }) => (
  <ul>
    {options.map(({ value, text }) => (
      <li key={value} role="none">
        <button
          role="menuitem"
          onMouseDown={(e) => {
            e.preventDefault();
            handleAddOptionClick(e, value);
          }}
          onTouchEnd={(e) => {
            e.preventDefault();
            handleAddOptionClick(e, value);
          }}
        >
          {text}
        </button>
      </li>
    ))}
  </ul>
);

AddOptionDropdown.propTypes = {
  handleAddOptionClick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
};

export default AddOptionDropdown;
